import React from 'react';
import { useTranslation } from 'react-i18next';

import Navbar from './Navbar';
import About from './About';

const Home = () => {
    const { t } = useTranslation();

    return (
        <div>
            <Navbar/>
            <section id="home">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 mt-5">
                            <h1 className="display-4 fw-bolder mb-4 text-center text-white title">APAFReP</h1>
                            <p className="lead text-center fs-2 fw-bolder mb-1 text-white">{t('banner_title')}</p>
                            <p className="lead text-center fs-4 mb-5 text-white">{t('banner_subtitle')}</p>
                        </div>
                    </div>
                </div>
            </section>
            <About/>
        </div>
    )
}

export default Home;